const pathNameToId = (str: string) =>
  // eslint-disable-next-line no-restricted-globals
  [location.pathname, str].join('-').replaceAll('/', '-').replace(/^-+/, '').toLowerCase()

export { pathNameToId }
